import React, { ReactElement } from 'react';
import { canEditBusiness, isBusinessOwner } from '../../utils/accessService';
import { useTranslation } from '../../utils/useTranslation';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Menu, MenuItem } from '../navigation/Menu';
import { Typography } from '../typography/Typography';
import { UserUI } from '../users/types';
import { PostUI } from './types';

interface PostContextMenuProps {
    trigger: ReactElement;
    onTriggerClick?: VoidFunction;
    post: PostUI;
    user?: UserUI;
    onEdit?: VoidFunction;
    onDraft?: VoidFunction;
    onRemove?: VoidFunction;
    onPublish?: VoidFunction;
    onSubscribe: VoidFunction;
    onReport?: VoidFunction;
    onShare?: VoidFunction;
    onShareCollection?: VoidFunction;
    appMenuItem?: ReactElement;
    moveToCollection?: VoidFunction;
    onEditPostCollection?: VoidFunction;
    returnFocusOnDeactivate?: boolean;
}

export function PostContextMenu(props: PostContextMenuProps) {
    const { trigger, post, user, onTriggerClick, appMenuItem, returnFocusOnDeactivate } = props;
    const t = useTranslation();

    if (post.business) {
        const subscribeItem = post.business.subscribed ? (
            <MenuItem onClick={props.onSubscribe} dataTestId={DataTestId.UNSUBSCRIBE_TEXT}>
                <Typography noWrap color="error">
                    {t('Отписаться')}
                </Typography>
            </MenuItem>
        ) : (
            <MenuItem onClick={props.onSubscribe} dataTestId={DataTestId.SUBSCRIBE_TEXT}>
                <Typography noWrap>{t('Подписаться')}</Typography>
            </MenuItem>
        );

        return (
            <Menu
                trigger={trigger}
                onTriggerClick={onTriggerClick}
                returnFocusOnDeactivate={returnFocusOnDeactivate}
                dataTestId={DataTestId.POST_CONTEXT_MENU}
            >
                {props.onShare ? (
                    <MenuItem onClick={props.onShare}>
                        <Typography noWrap>{t('Поделиться')}</Typography>
                    </MenuItem>
                ) : undefined}
                {canEditBusiness(post.business.id, user) && props.onEdit ? (
                    <MenuItem onClick={props.onEdit}>
                        <Typography noWrap>{t('Редактировать')}</Typography>
                    </MenuItem>
                ) : undefined}
                {canEditBusiness(post.business.id, user) && props.onPublish ? (
                    <MenuItem onClick={props.onPublish}>
                        <Typography noWrap>{t('Опубликовать')}</Typography>
                    </MenuItem>
                ) : undefined}
                {canEditBusiness(post.business.id, user) && props.onDraft ? (
                    <MenuItem onClick={props.onDraft}>
                        <Typography noWrap>{t('Вернуть в черновики')}</Typography>
                    </MenuItem>
                ) : undefined}
                {canEditBusiness(post.business.id, user) && props.onRemove ? (
                    <MenuItem onClick={props.onRemove}>
                        <Typography noWrap>{t('Удалить')}</Typography>
                    </MenuItem>
                ) : undefined}
                {isBusinessOwner(post.business.id, user) ? undefined : subscribeItem}
                {!canEditBusiness(post.business.id, user) && props.onReport ? (
                    <MenuItem onClick={props.onReport}>
                        <Typography noWrap color="error">
                            {t('Пожаловаться')}
                        </Typography>
                    </MenuItem>
                ) : undefined}
                {appMenuItem}
            </Menu>
        );
    } else {
        return (
            <Menu
                trigger={trigger}
                onTriggerClick={onTriggerClick}
                dataTestId={DataTestId.POST_CONTEXT_MENU}
            >
                {props.onShare ? (
                    <MenuItem onClick={props.onShare}>
                        <Typography noWrap>{t('Поделиться')}</Typography>
                    </MenuItem>
                ) : undefined}
                {post.ownersData?.isOwner && props.onRemove ? (
                    <MenuItem onClick={props.onRemove}>
                        <Typography noWrap>{t('Удалить')}</Typography>
                    </MenuItem>
                ) : undefined}
                {!post.ownersData?.isOwner && props.onReport ? (
                    <MenuItem onClick={props.onReport}>
                        <Typography noWrap color="error">
                            {t('Пожаловаться')}
                        </Typography>
                    </MenuItem>
                ) : undefined}
                {appMenuItem}
            </Menu>
        );
    }
}
